// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarDayOutline16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-day-outline': IconCalendarDayOutline;
    }
}

/**
 * The icon component for the 'calendarDayOutline' icon
 */
export class IconCalendarDayOutline extends Icon {
    public constructor() {
        super(calendarDayOutline16X16);
    }
}

registerIcon('icon-calendar-day-outline', IconCalendarDayOutline);
export const iconCalendarDayOutlineTag = 'nimble-icon-calendar-day-outline';
